import { SignJWT } from 'jose';
import * as jose from 'jose';

// Configuration des variables d'environnement
const ENV = {
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
  OAUTH_AUTHORIZATION_URL: import.meta.env.VITE_REDIRECT_Otenti,
  POST_LOGOUT_URI: import.meta.env.VITE_REDIRECT_post_logout_redirect_uri,
  CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  CLIENT_SECRET: import.meta.env.VITE_CLIENT_SECRET,
  USER_TYPE: import.meta.env.VITE_USER_TYPE,
  AUDIENCE: import.meta.env.VITE_AUDIENCE,
  PRIVATE_KEY_PATH: import.meta.env.VITE_PRIVATE_KEY_PATH
};

// Helper functions
const base64URLEncode = (buffer: ArrayBuffer): string => {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

const generateCodeVerifier = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64URLEncode(array.buffer);
};

const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const hash = await crypto.subtle.digest(
    'SHA-256',
    encoder.encode(verifier)
  );
  return base64URLEncode(hash);
};

// Génération JWT
const generateClientAssertion = async (): Promise<string> => {
  // const privateKey = await loadPrivateKey();
 
   const privatekey= `-----BEGIN PRIVATE KEY-----
   MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDYgoU9YKfEgqdm
   KslPdvuK0++l5abCmsccCUIIf9tQoPIWMpzUBObVrUReJ0NmfwhedkHu/khemRj8
   W0MTiub5b6ntYlgOFKigkUbxeoIMZU2kYqOqxL/LC801Cx+YfvIEY2O6gA8aZxTv
   CDrZB5Zy1UvU5OSlwicafI/G+icDTdb51xE9cN77Hwx/WsRepzR3ZJBn7da7dyHJ
   JZR2Qd/IpMI7LxL1U1SGeaORHoS6wFkSaM3l67ieKyOgRw25x8qAayIHNFNw7pl4
   VWPIqTHaj/tApxoXwZugGf3JgVXr/D7l+CJ9QdGCgsIZK86UKa2q2TU8s9vAbq+u
   Y0Eh9THzAgMBAAECggEAOUc+bKB3gdt24eaL34QAxBeRnPgGiBFef6JLX+hDYy9R
   HGJDbyvkzb7LCYWlpSYSVrs+cjW/e5dRLuIN+suSk4bhE7YiyYbZnbERba0VXqYm
   Rkj6N6FZhCQZI+FPeI6NBHAu4BYk6L1AooQw3V3OhY68QxRTES8uHSm6988SJyMh
   3jSnXBmVPi9zxfqZ37G9mewld9FYBFJEsi7YYbkAS9pg93YhiTKlH9rn2fusDHSk
   svAD79ULlT1Ntax+y4qqbwUF+mGmVu1QUdjGoAHeR7lIH9dFJXZAP2Kl5xjfgs7t
   LYVmPGLGxSdFn/LWNYjYiZ4PtRNENHdIPp1yMYzI4QKBgQD6qoTY9BkBmhUibEx/
   /E1LGVZP3aEAGxHbz+zAXRbAowbSL2ETm6FWQy07C/lLHxGCd5PtgMy5UgPi7Iu+
   3aFOn9ktJjr3E0XLcHo7EH+dT1GxMIKtF+JumRMDZIOk8LE9Ts2/P15R4OBWhm9g
   aJnAgYxPATHsew+ObzlXhF9ouQKBgQDdHfA+eg39N2P0F/tXGiehrBvJPMzTeMLt
   2QpeYZ2rlNkxfPMLJJjE92AFV/D0n3twK26R57hUC7v0Ul3WSU2VKPUa89HtSwff
   6Lb6KvCzQv0WkyYJDrR6o5W1prbl0P+0IBcMe/n0RycALqZ8ondMAalejXC6nz2S
   nap5+bxCCwKBgDquHHdlfU0gsv3h+G6ls7p27fu4WG5b5+xbWoMVx7PE9l3R9ZnP
   fw9gnoAKJ4vsc/7k215oHoTrrDk9QuGlpJNxXDfzkS4x9s7PP+3/yMAcx3UBdDXt
   N3bIoujSaPb92aAOiJ/Sx9PHHv1ib0RUeFnWefAsyXEgxd2EMBpKxMMRAoGAA2XF
   XkBj3KMwPvzrWMBHIZ3SY3oyr4EohZ0TIrYfRRapa7A+z8oFKumeKRbb1fZpYCTa
   sxU7aNcxUSS+2l8P+R3C/mIGtL21ZkReI2PrhOWfm+ww5my6azP+RedE4i0e8LaZ
   hBCXm6BIQiF1X27jpGBWKOTFeaieupT/nJYwxVcCgYBDOxraZdHlH1Jt7FdyouGo
   ON6LGH1vtHwS5YMPB1CCfpKgQy2itrTaDKsseJsr5m1sUY8LPW2KfePvTzAI3z5d
   DyFhn7SA3QQe3UfuMRU5MRSfSuSr/s4ZXoOr7JssIirUIx0Aih86Dihp+P0mIl+7
   ol2xhbK1fg+kaOT2We0L4A==
   -----END PRIVATE KEY-----`;
   
   const privateKey2 = await jose.importPKCS8( privatekey.trim(), 'RS256');
  return new SignJWT({
    client_id: ENV.CLIENT_ID,
    iss: ENV.CLIENT_ID,
    sub: ENV.CLIENT_ID,
    aud: ENV.AUDIENCE
  })
    .setProtectedHeader({ alg: 'RS256', kid: ENV.CLIENT_ID })
    .setIssuedAt()
    .setExpirationTime('5m')
    .sign(privateKey2);
};

// Flux OAuth
export const initiateAdminOAuthLogin = async () => {
  try {
    const [jwt, codeVerifier] = await Promise.all([
      generateClientAssertion(),
      generateCodeVerifier()
    ]);

    localStorage.setItem('code_verifier', codeVerifier);
    
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: ENV.CLIENT_ID,
      redirect_uri: ENV.REDIRECT_URI,
      scope: 'openid email profile offline_access',
      code_challenge: await generateCodeChallenge(codeVerifier),
      code_challenge_method: 'S256',
      client_assertion: jwt,
      client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
      state: crypto.randomUUID(),
      user_type: ENV.USER_TYPE
    });

    window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/authorize?${params}`;
  } catch (error) {
    console.error('Erreur authentification:', error);
    // Gérer l'erreur
  }
};

// Déconnexion
export const initiateLogOut = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('code_verifier');

  const params = new URLSearchParams({
    client_id: ENV.CLIENT_ID,
    post_logout_redirect_uri: ENV.POST_LOGOUT_URI
  });

  window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/logout?${params}`;
};

export default { initiateAdminOAuthLogin, initiateLogOut };





// / import axios, { AxiosError } from 'axios';
import axios from 'axios';
// import react from 'react';
import { useNavigate } from 'react-router-dom';

export const logout = async (): Promise<void> => {
   
    const navigate = useNavigate();

    const VITE_REDIRECT_Otenti = import.meta.env.VITE_REDIRECT_Otenti;
    try {
        await axios.post(`${VITE_REDIRECT_Otenti}/connect/logout`,{}, {
            // headers: {
                
            //     'Content-Type': 'application/x-www-form-urlencoded',

            //     Authorization: `Bearer ${token}`
            // }
            withCredentials:true

        });

        // Supprimer le token d'authentification du stockage local
        localStorage.removeItem('access_token');
    localStorage.removeItem('company');
    localStorage.removeItem('appId');

    // Rediriger vers la page de connexion
    navigate('/');
    // window.location
 


        // Invalider les caches SWR si nécessaire
        // mutate('/some/endpoint/to/invalidate'); // Exemple, ajustez selon vos besoins

        console.log('Déconnexion réussie');
    } catch (error) {
        // handleError(error);
        throw error;
    }
};